import { ISelectOption } from '../../../ui-toolkit';

export const transformLabelValueToValue = (selectedOption: ISelectOption) => selectedOption?.value ?? null;
